// extracted by mini-css-extract-plugin
export default {"two_btn_popup":"TwoButtonPopup_two_btn_popup__tT0NX","two_btn_popup_text":"TwoButtonPopup_two_btn_popup_text__ZHsxb","popup_button":"TwoButtonPopup_popup_button__fZdI8"};